var PracticeTurn = /* @__PURE__ */ ((PracticeTurn2) => {
  PracticeTurn2["user"] = "user";
  PracticeTurn2["operator"] = "cafOperator";
  PracticeTurn2["finalized"] = "finalized";
  return PracticeTurn2;
})(PracticeTurn || {});
export {
  PracticeTurn
};
//# sourceMappingURL=practice-turn.es.js.map
